import { flow } from 'fp-ts/function';
import { GUID_PATTERN } from '../../constants';

const guidPattern = new RegExp(GUID_PATTERN, 'g');
const replaceGuid = (text: string) => text.replace(guidPattern, '__UUID__');

export const getNormalizedPathname = flow((context: Window) => context.location.pathname, replaceGuid);
